import { DXR, Options, RichEdit, useRichEdit } from './dx-richedit';
import React, { useLayoutEffect, useRef } from 'react';
import { mergeRefs } from 'react-merge-refs';
import 'devexpress-richedit/dist/dx.richedit.css';
import styles from './RichEditComponent.module.scss';

export type Props = {
  onLoaded?: () => void;
  initialize?: (options: Options) => void;
  richEditRef: React.MutableRefObject<RichEdit>;
};
export const RichEditComponent = React.forwardRef<HTMLDivElement, Props>(
  function DocumentNonLazy(props, ref) {
    const richEditWrapperRef = useRef<HTMLDivElement>(null);
    useRichEdit();

    const richEdit = useRef<RichEdit>(null!);
    const richEditDisposeTimerIdRed = useRef<ReturnType<
      typeof setTimeout
    > | null>(null);
    useLayoutEffect(() => {
      // this is to prevent disposing RichEdit in React StrictMode (with double-invoking of events)
      // otherwise there's an error "Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node."
      if (richEditDisposeTimerIdRed.current) {
        clearTimeout(richEditDisposeTimerIdRed.current);
        return;
      }
      // the createOptions() method creates an object that contains RichEdit options initialized with default values
      const options = DXR.createOptions();
      options.bookmarks!.visibility = false;
      options.bookmarks!.color = '#ff0000';
      options.confirmOnLosingChanges!.enabled = false;
      // options.confirmOnLosingChanges!.message =
      //   'Are you sure you want to perform the action? All unsaved document data will be lost.';
      options.fields!.updateFieldsBeforePrint = true;
      options.fields!.updateFieldsOnPaste = true;

      options.unit = DXR.RichEditUnit.Centimeter;

      options.view!.viewType = DXR.ViewType.PrintLayout;
      options.view!.simpleViewSettings!.paddings = {
        left: 15,
        top: 15,
        right: 15,
        bottom: 15,
      };
      options.readOnly = false;
      options.width = '100%';
      options.height = 'calc(100%)';

      options.ribbon.removeTab(DXR.RibbonTabType.View);
      options.ribbon.removeTab(DXR.RibbonTabType.MailMerge);
      options.ribbon.activeTabIndex = 0;

      props.initialize?.(options);

      richEdit.current = DXR.create(richEditWrapperRef.current!, options);
      props.richEditRef.current = richEdit.current;

      setTimeout(() => {
        // delay update ribbon menu to speed up initial loading of control
        props.onLoaded?.();
      }, 1);

      return () => {
        try {
          richEditDisposeTimerIdRed.current = setTimeout(() => {
            richEdit.current?.dispose();
            richEditDisposeTimerIdRed.current = null;
          }, 10);
        } catch (e) {}
      };
    }, []);
    return (
      <div
        className={styles.document}
        ref={mergeRefs([richEditWrapperRef, ref])}
        id="richEdit"
      ></div>
    );
  },
);
